// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  baseUrl: '',
  version: '3.23.0.beta.1',
  oauthClientSecret: 'O4ALtEYuVT08d0mddu2iHkJWrGpnaFpuPXP0rXYR',
  am4LiceneKey: 'CH328658722',
  sentry: {
    active: false,
    dsn: {
      admin: 'https://5e351e67909b4daf9a6aeec3e38f3b5c@o4505397184561152.ingest.sentry.io/4505425168039936',
      runner: 'https://fa45345c588f4a1caf66aaefc3d18613@o4505397184561152.ingest.sentry.io/4505425180426240',
      toolbox: 'https://693e7ada4f704b24b600892bdab94aae@o4505397184561152.ingest.sentry.io/4505425182457856',
    },
    stage: 'test'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
